import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title \"Invoices\"}}\n\n<NwNavbar />\n\n<NwPageLocationBanner>\n  <:first>Invoices</:first>\n</NwPageLocationBanner>\n\n<Invoices::InvoicesList @invoices={{@model}} />")